"use client";
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
// استخدام موديول المكعب الفخم بدلاً من التلاشي
import { Autoplay, EffectCube, Pagination } from 'swiper/modules';
import { Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';

// استيراد الستايلات الخاصة بـ Swiper وتأثير المكعب والـ Pagination
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-cube';

export default function HomeBanner() {
  const slidesData = [
    {
      id: 1,
      imagePath: "/1.png", 
      altText: "عروض إنترنت المكسات والـ 5G",
      linkUrl: "#offers-1"
    },
    {
      id: 2,
      imagePath: "/2.png",
      altText: "خدمات محفظة LaserJet Pay الجديدة",
      linkUrl: "#offers-2"
    },
    {
      id: 3,
      imagePath: "/3.png",
      altText: "باقات الإنترنت المنزلي الفايبر الفائقة",
      linkUrl: "#offers-3"
    }
  ];

  return (
    <div 
      className="w-full relative group overflow-visible" 
      dir="rtl"
      style={{ perspective: 1200 }} // للحفاظ على عمق تأثير المكعب ثلاثي الأبعاد
    >
      <motion.div
        initial={{ y: 40, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="w-full relative overflow-hidden shadow-[0_20px_50px_-15px_rgba(24,35,189,0.15)] bg-[#020b18]"
      >
        <Swiper
          effect={'cube'} 
          grabCursor={true}
          cubeEffect={{
            shadow: false, // إيقاف الظل الأسود السفلي الافتراضي لعدم تخريب أبعاد البانر
            slideShadows: true, // تفعيل ظلال الجوانب لتعزيز التأثير ثلاثي الأبعاد أثناء الدوران
            shadowOffset: 0,
            shadowScale: 1,
          }}
          centeredSlides={true}
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          modules={[Autoplay, EffectCube, Pagination]}
          // تحديث الارتفاعات لتناسب الشاشات الصغيرة جداً دون قص محتوى الصور الصغير
          className="w-full h-[160px] xs:h-[180px] sm:h-[220px] md:h-[280px] lg:h-[340px] xl:h-[380px] 2xl:h-[420px]"
        >
          {slidesData.map((slide) => (
            <SwiperSlide key={slide.id} className="overflow-hidden w-full h-full bg-[#020b18]">
              
              {/* شارة العروض الذكية المستقرة أعلى اليمين */}
              <div className="absolute top-3 right-3 sm:top-6 sm:right-6 z-30 bg-black/40 backdrop-blur-md text-white text-[9px] sm:text-xs font-black px-3 py-1.5 sm:px-4 sm:py-2 rounded-full flex items-center gap-1.5 sm:gap-2 shadow-xl border border-white/10 pointer-events-none">
                <Sparkles className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-[#3fd5b7] animate-spin" style={{ animationDuration: '3s' }} />
                <span>عروض حصرية ومباشرة</span>
              </div>

              <a 
                href={slide.linkUrl} 
                className="block w-full h-full relative overflow-hidden focus:outline-none"
                aria-label={slide.altText}
              >
                <motion.img 
                  src={slide.imagePath} 
                  alt={slide.altText}
                  whileHover={{ scale: 1.01 }}
                  transition={{ duration: 0.6, ease: "easeOut" }}
                  // تعديل كلاس الـ object: نستخدم fill على الشاشات الكبيرة و contain أو cover محسّن للموبايل لمنع ضياع التفاصيل أو النصوص
                  className="w-full h-full object-fill sm:object-cover md:object-fill object-center select-none pointer-events-none"
                  loading={slide.id === 1 ? "eager" : "lazy"}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent pointer-events-none" />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </motion.div>   
    </div>
  );
}